export default {
  // 是否是手机
  isPoneAvailable(pone) {
    var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
    if (!myreg.test(pone)) {
      return false;
    } else {
      return true;
    }
  },
  // 验证邮箱
  isEmail(email) {
    var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    if (!reg.test(email)) {
      return false;
    } else {
      return true;
    }
  },

  // 验证金额
  isDigit(s) {
    var patrn = /^(\d+)$|^(\d+\.\d{0,2})$/;
    return patrn.test(s)
  },

  // 验证不为0的金额
  isPosDigit(s) {
    var patrn = /^[1-9]\d*$|^(\d+\.\d{0,2})$/;
    return patrn.test(s)
  },

  // 验证密码
  validatePwd(str) {
    if (
        /^.*?[\d]+.*$/.test(str) &&
        /^.*?[A-Za-z]/.test(str) &&
        /^.*?[~/`!@#$%^&*()_+|{}?;:><\-\]\\[\/].*$/.test(str) &&
        /^.{8,20}$/.test(str)
    ) {
      return true;
    }
    return false;
  },

  // 判断是否是汉字
  isCharacter(charValue) {
    var reg = /^[\u4e00-\u9fa5]{0,}$/;
    return reg.test(charValue);
  },

  // 判断是否是字母
  isChar(charValue) {
    var charPattern = /^[a-zA-Z]*$/; // 是否为字母
    var result = charPattern.test(charValue);
    return result;
  },

  // 判断是否数字
  isNum(numValue) {
    var numPattern = /^\d*$/;
    var result = numPattern.test(numValue);
    return result;
  },
  
   //判断是否为整数或者小数
  isDecNum(value) { 
    return /^\d+(\.\d+)?$/.test(value) 
  },

  // 整数的正则表达式
  isInt(intValue) {
    var intPattern = /^0$|^[1-9]\d*$/;
    var result = intPattern.test(intValue);
    return result;
  },
  
  // 正整数
  isPosInte(val) {
    var intPattern = /^[1-9]\d*$/;
    return intPattern.test(val);;
  },

  //2-100 的整数
  isTwoToHundred(val) {
    var intPattern = /^[2-9]$|^[1-9][0-9]$|^100$/;
    return intPattern.test(val);;
  },

  // 是否为字母和数字
  isCharNum(flagValue) {
    var flagPattern = /^[a-zA-Z0-9]*$/;
    var result = flagPattern.test(flagValue);
    return result;
  },

  /**
   * 检验18位身份证号码（15位号码可以只检测生日是否正确即可，自行解决）
   *
   * @param idCardValue
   *   18位身份证号
   * @returns 匹配返回true 不匹配返回false
   */
  idCardVildate(code) {
    var city = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外 ',
    };
    var pass = true;

    if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
            code
        )
    ) {
      pass = false;
    } else if (!city[code.substr(0, 2)]) {
      pass = false;
    } else {
      // 18位身份证需要验证最后一位校验位
      if (code.length == 18) {
        code = code.split('');
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (parity[sum % 11] != code[17]) {
          pass = false;
        }
      }
    }
    return pass;
  }
};
